import Cust from './Cust';

export default Cust;
